export const changeOfMeteringSchema = {
  title: 'Change of Metering',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'object',
      title: 'MPAN Core',
      properties: {
        name: { type: 'string' },
        energisationStatus: { type: 'string' },
      },
    },
    appointment_date: {
      type: 'string',
      title: 'Appointment Date',
    },
    earliest_appointment_time: {
      type: 'string',
      title: 'Earliest Appointment Time',
    },
    latest_appointment_time: {
      type: 'string',
      title: 'Latest Appointment Time',
    },
    requested_energisation_status: {
      type: 'string',
      title: 'Requested Energisation Status',
      description: 'Auto-filled based on meter point supply history',
    },
    additional_information: {
      type: 'string',
      title: 'Additional Information',
    },
    remove_all_meters: {
      type: 'boolean',
      title: 'Remove All Meters',
      default: false,
    },
    retrieval_method: {
      type: 'string',
      title: 'Retrieval Method',
      enum: ['H', 'M', 'N', 'R', 'S', 'U'],
      enumNames: ['H – Half-Hourly', 'M – Manual', 'N – Non-Retrievable', 'R – Remote', 'S – Smart', 'U – Unmetered'],
    },
    ssc_id: {
      type: 'string',
      title: 'SSC ID',
    },
  },
  required: [
    'mpan_core',
    'appointment_date',
    'earliest_appointment_time',
    'latest_appointment_time',
    'remove_all_meters',
    'retrieval_method',
  ],
};

export const changeOfMeteringUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
    'ui:options': { label: true },
    name: { 'ui:widget': 'hidden' },
    energisationStatus: { 'ui:widget': 'hidden' },
  },
  appointment_date: {
    'ui:placeholder': 'Select date',
  },
  earliest_appointment_time: {
    'ui:placeholder': 'Select time',
  },
  latest_appointment_time: {
    'ui:placeholder': 'Select time',
  },
  requested_energisation_status: {
    'ui:readonly': true,
    'ui:placeholder': 'Auto-filled from meter point',
  },
  additional_information: {
    'ui:widget': 'textarea',
    'ui:placeholder': 'Enter additional information (optional)',
    'ui:options': {
      rows: 4,
    },
  },
  remove_all_meters: {
    'ui:widget': 'checkbox',
  },
  retrieval_method: {
    'ui:placeholder': 'Select Retrieval Method',
  },
  ssc_id: {
    'ui:placeholder': 'Select SSC ID',
  },
};
